import React from 'react';
import { Box, Button, useMediaQuery } from '@mui/material';
import { AddBoxOutlined } from '@mui/icons-material';
import Header from '../../components/Header';
import { useSelector } from 'react-redux';
import GroupSelector from '../../components/GroupSelector';

const DevicesHeader = ({ handleOpenDialog, theme, selectedGroup, handleGroupChange, groupOptions }) => {
    const { role } = useSelector((state) => state.global);
    const isAdmin = role === 'Admin';
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const hasGroups = Array.isArray(groupOptions) && groupOptions.length > 0;

    return (
        <Box
            display="flex"
            justifyContent="space-between"
            marginBottom="1rem"
            padding="1rem"
            backgroundColor={theme.palette.background.paper}
            borderRadius="15px"
            sx={{
                boxShadow: '8px 8px 20px rgba(0, 0, 0, 0.1)',
                flexDirection: isSmallScreen ? 'column' : 'row',
            }}
        >
            <Header title="DEVICES" subtitle="View your list of devices." />

            {!isSmallScreen && (
                <Box display="flex" alignItems="center" gap={2}>
                    {hasGroups && <GroupSelector selectedGroup={selectedGroup} handleGroupChange={handleGroupChange} groupOptions={groupOptions} />}
                    {isAdmin && (
                        <Button
                            onClick={handleOpenDialog}
                            sx={{
                                backgroundColor: theme.palette.text.white,
                                color: theme.palette.text.black,
                                padding: '0rem 1rem',
                                '&:hover': {
                                    backgroundColor: theme.palette.text.white,
                                },
                                '&:focus': {
                                    outline: 'none',
                                },
                                p: '1rem',
                                width: '250px',
                            }}
                        >
                            <AddBoxOutlined sx={{ marginRight: '8px' }} />
                            Add Device
                        </Button>
                    )}
                </Box>
            )}
        </Box>
    );
};

export default DevicesHeader;
